/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";

import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 2000 // Set animation duration as per your animation
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "Larry Margerum",
  title: "Hi, I'm Larry Margerum",
  subTitle: emoji(
    "I'm a Full Stack AI Engineer with a strong interest in Machine Learning, Deep Learning, and Generative AI. I enjoy building end-to-end applications that combine modern web technologies with intelligent AI solutions. My experience includes developing scalable web applications, integrating large language models (LLMs), building AI agents, and creating APIs that power real-world AI products."
  ),
  resumeLink:
    "https://flowcv.com/resume/hilsned237sd", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links
const socialMediaLinks = {
  github: "https://github.com/larrymargerum01",
  linkedin: "https://www.linkedin.com/in/larrymargerum01/",
  gmail: "larrymargerum1950@gmail.com",
  gitlab: "https://gitlab.com/larrymargerum1950",
  stackoverflow: "https://stackoverflow.com/users/32920747/larry-margerum",
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "What I do",
  subTitle: "",
  skills: [
    emoji(
      "⚡ Build intelligent applications using LLMs, RAG, AI agents, and automation workflows."
    ),
    emoji("⚡ Develop document intelligence, research assistants, and knowledge-based AI solutions."),
    emoji(
      "⚡ Create scalable web applications, APIs, and AI-powered platforms."
    ),
    emoji("⚡ Transform data into insights through analysis, visualization, and intelligent processing.")
  ],

  /* Make Sure to include correct Font Awesome Classname to view your icon
https://fontawesome.com/icons?d=gallery */

  softwareSkills: [
    {
      skillName: "Python",
      fontAwesomeClassname: "fab fa-python"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fas fa-typescript"
    },
    {
      skillName: "React.js",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fas fa-next"
    },
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "FastAPI",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fab fa-mongodb"
    },
    {
      skillName: "Machine Learning",
      fontAwesomeClassname: "fas fa-brain"
    },
    {
      skillName: "Deep Learning",
      fontAwesomeClassname: "fas fa-network-wired"
    },
    {
      skillName: "LangChain",
      fontAwesomeClassname: "fas fa-link"
    },
    {
      skillName: "Retrieval-Augmented Generation",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "Hugging Face Transformers",
      fontAwesomeClassname: "fas fa-robot"
    },
    {
      skillName: "Large Language Models",
      fontAwesomeClassname: "fas fa-language"
    },
    {
      skillName: "PyTorch",
      fontAwesomeClassname: "fas fa-fire"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Git & GitHub",
      fontAwesomeClassname: "fab fa-github"
    },
    {
      skillName: "AI Security",
      fontAwesomeClassname: "fas fa-shield-alt"
    },
    {
      skillName: "Prompt Engineering",
      fontAwesomeClassname: "fas fa-terminal"
    },
    {
      skillName: "Prompt Injection Prevention",
      fontAwesomeClassname: "fas fa-user-shield"
    },
    {
      skillName: "Secure LLM Deployment",
      fontAwesomeClassname: "fas fa-lock"
    },
    {
      skillName: "RESTful API Development",
      fontAwesomeClassname: "fas fa-code"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "AGH University of Krakow",
      subHeader: "Bachelor of Computer Science'",
      duration: "Oct 2020 - Jul 2024",
      desc: "Studied Computer Science with a specialization in artificial intelligence, covering machine learning, deep learning, natural language processing, computer vision, and full-stack software development.",
      descBullets: [
        "Focus on Machine Learning, Deep Learning, and Data-Intensive Systems",
        "Strong foundation in algorithms, data structures, and distributed systems",
        "Practical experience through research-oriented and project-based learning",
        "Rich experience in building full-stack applications with AI integration",
      ]
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, //Set it to true to show Proficiency Section
  experience: [
    {
      stackName: "AI & Generative AI",
      progressPercentage: 95
    },
    {
      stackName: "Backend Development",
      progressPercentage: 90
    },
    {
      stackName: "Frontend Development",
      progressPercentage: 85
    },
    {
      stackName: "Cloud & DevOps",
      progressPercentage: 80
    }
  ],
  displayCodersrank: false // Set true to display codersrank badges section need to changes your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, //Set it to true to show workExperiences Section
  experience: [
    {
      role: "Full Stack AI Engineer",
      company: "Remote  / N-iX⁠",
      date: "Feb 2024 – Jun 2026",
      descBullets: [
        "Designed and developed 4 AI-powered SaaS platforms using React, Next.js, FastAPI, and Python",
        "Built Retrieval-Augmented Generation (RAG) pipelines with vector databases, improving retrieval accuracy by 27%",
        "Developed AI agents that automated document processing, reducing manual effort by 65%",
        "Optimized backend services handling 120,000+ API requests per month while maintaining 99.9% availability",
        "Reduced inference costs by 22% through prompt optimization, caching, and asynchronous processing",
        "Mentored 2 junior developers and participated in architecture reviews"
      ]
    },
    {
      role: "Full Stack Developer",
      company: "Remote / Synebo",
      date: "Sep 2022 – Dec 2023",
      descBullets: [
        "Delivered 8+ enterprise web applications using React, Node.js, TypeScript, and PostgreSQL",
        "Reduced frontend load time by 35% through code splitting and performance optimization",
        "Built APIs processing 50,000+ monthly requests",
        "Increased automated test coverage from 55% to 88%",
        "Reduced deployment time by 40% using Docker and GitHub Actions"
      ]
    },
    {
      role: "AI Engineering Intern",
      company: "Brainly",
      date: "June 2022 – Aug 2022",
      descBullets: [
        "Developed an AI-powered learning assistant using Python, FastAPI, React, and OpenAI APIs, reducing response latency by 30%",
        "Built REST APIs supporting 10,000+ daily requests",
        "Improved prompt engineering strategies, increasing answer relevance by 18%",
        "Collaborated with a cross-functional Agile team of 6 engineers",
        "Achieved 92% unit test coverage for backend modules"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "true", // Set true or false to show Contact profile using Github, defaults to true
  display: false // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "SOME STARTUPS AND COMPANIES THAT I HELPED TO CREATE THEIR TECH",
  projects: [
    {
      projectName: "AI Document Intelligence",
      projectDesc: "Developed a Document Intelligence platform that automates document processing using OCR, NLP, and AI to extract, classify, and validate structured information from PDFs, invoices, forms, and scanned documents with high accuracy",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/larrymargerum01/Document-Intelligence"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // image: require("./assets/images/nextuLogo.webp"),
      projectName: "RAG Knowledge Assistant⁠",
      projectDesc: "Built a Retrieval-Augmented Generation (RAG) Assistant that combines semantic search with LLMs to provide accurate, context-aware responses from custom knowledge bases. Features document ingestion, vector search, and conversational Q&A with source-aware answers",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/larrymargerum01/RAG-Assistant"
        }
      ]
    },
    {
      projectName: "AI Resume Analyzer",
      projectDesc: "Built an AI-powered Resume Analyzer that evaluates resumes against job descriptions, extracts key skills and experience, provides ATS compatibility scores, identifies skill gaps, and generates personalized improvement recommendations using NLP and LLMs",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/larrymargerum01/Resume-Analyzer"
        }
        //  you can add extra buttons here.
      ]
    },
    {
      // image: require("./assets/images/nextuLogo.webp"),
      projectName: "Multi-Agent Research Assistant⁠⁠",
      projectDesc: "Developed a Multi-Agent Research Assistant that coordinates specialized AI agents to search, analyze, summarize, and synthesize information from multiple sources, delivering comprehensive, citation-backed research reports and actionable insights",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/larrymargerum01/Multi-Agent-Research-Assistant"
        }
      ]
    },
    {
      // image: require("./assets/images/nextuLogo.webp"),
      projectName: "Full Stack AI SaaS Platform⁠⁠⁠",
      projectDesc: "Built an AI SaaS Platform that enables users to access multiple AI-powered tools through a unified dashboard, including content generation, document analysis, chat assistants, and workflow automation with secure authentication and subscription management",
      footerLink: [
        {
          name: "Visit Github",
          url: "https://github.com/larrymargerum01/AI-Sass-Platform"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Achievement Section
// Include certificates, talks etc

const achievementSection = {
  title: emoji("Achievements And Certifications 🏆 "),
  subtitle:
    "Achievements, Certifications, Award Letters and Some Cool Stuff that I have done !",

  achievementsCards: [
    {
      title: "Google Code-In Finalist",
      subtitle:
        "First Pakistani to be selected as Google Code-in Finalist from 4000 students from 77 different countries.",
      // image: require("./assets/images/codeInLogo.webp"),
      imageAlt: "Google Code-In Logo",
      footerLink: [
        {
          name: "Certification",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dYkVvNjdNWjNybWJrbndFSHpNY2NFV1p4YmU0/view?usp=sharing"
        },
        {
          name: "Award Letter",
          url: "https://drive.google.com/file/d/0B7kazrtMwm5dekxBTW5hQkg2WXUyR3QzQmR0VERiLXlGRVdF/view?usp=sharing"
        },
        {
          name: "Google Code-in Blog",
          url: "https://opensource.googleblog.com/2019/01/google-code-in-2018-winners.html"
        }
      ]
    },
    {
      title: "Google Assistant Action",
      subtitle:
        "Developed a Google Assistant Action JavaScript Guru that is available on 2 Billion devices world wide.",
      // image: require("./assets/images/googleAssistantLogo.webp"),
      imageAlt: "Google Assistant Action Logo",
      footerLink: [
        {
          name: "View Google Assistant Action",
          url: "https://assistant.google.com/services/a/uid/000000100ee688ee?hl=en"
        }
      ]
    },

    {
      title: "PWA Web App Developer",
      subtitle: "Completed Certifcation from SMIT for PWA Web App Development",
      // image: require("./assets/images/pwaLogo.webp"),
      imageAlt: "PWA Logo",
      footerLink: [
        { name: "Certification", url: "" },
        {
          name: "Final Project",
          url: "https://pakistan-olx-1.firebaseapp.com/"
        }
      ]
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Blogs Section

const blogSection = {
  title: "Blogs",
  subtitle:
    "With Love for Developing cool stuff, I love to write and teach others what I have learnt.",
  displayMediumBlogs: "true", // Set true to display fetched medium blogs instead of hardcoded ones
  blogs: [
    {
      url: "https://blog.usejournal.com/create-a-google-assistant-action-and-win-a-google-t-shirt-and-cloud-credits-4a8d86d76eae",
      title: "Win a Google Assistant Tshirt and $200 in Google Cloud Credits",
      description:
        "Do you want to win $200 and Google Assistant Tshirt by creating a Google Assistant Action in less then 30 min?"
    },
    {
      url: "https://medium.com/@saadpasta/why-react-is-the-best-5a97563f423e",
      title: "Why REACT is The Best?",
      description:
        "React is a JavaScript library for building User Interface. It is maintained by Facebook and a community of individual developers and companies."
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Talks Sections

const talkSection = {
  title: "TALKS",
  subtitle: emoji(
    "I LOVE TO SHARE MY LIMITED KNOWLEDGE AND GET A SPEAKER BADGE 😅"
  ),

  talks: [
    {
      title: "Build Actions For Google Assistant",
      subtitle: "Codelab at GDG DevFest Karachi 2019",
      slides_url: "https://bit.ly/saadpasta-slides",
      event_url: "https://www.facebook.com/events/2339906106275053/"
    }
  ],
  display: false // Set false to hide this section, defaults to true
};

// Podcast Section

const podcastSection = {
  title: emoji("Podcast 🎙️"),
  subtitle: "I LOVE TO TALK ABOUT MYSELF AND TECHNOLOGY",

  // Please Provide with Your Podcast embeded Link
  podcast: [
    "https://anchor.fm/codevcast/embed/episodes/DevStory---Saad-Pasta-from-Karachi--Pakistan-e9givv/a-a15itvo"
  ],
  display: false // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",

  // Please Provide with Your Podcast embeded Link
  display: true // Set false to hide this section, defaults to true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "+1 (202) 681-5715",
  email_address: "larrymargerum1950@gmail.com"
};

// Twitter Section

const twitterDetails = {
  userName: "twitter", //Replace "twitter" with your twitter username without @
  display: false // Set true to display this section, defaults to false
};

const isHireable = true; // Set false if you are not looking for a job. Also isHireable will be display as Open for opportunities: Yes/No in the GitHub footer

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  achievementSection,
  blogSection,
  talkSection,
  podcastSection,
  contactInfo,
  twitterDetails,
  isHireable,
  resumeSection
};
